import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { brandPalette } from "../../constants/brandPalette";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
} from "./admin-modal-theme";

/**
 * Shared delete confirmation dialog for admin tables.
 */
const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete item?",
  itemName,
  message = "This action cannot be undone.",
  confirmLabel = "Delete",
  isLoading = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(2px)" />
      <ModalContent {...adminModalContentProps}>
        <ModalHeader
          {...adminModalHeaderProps}
          fontSize="24px"
          fontWeight="800"
          color="var(--text-primary)"
          fontFamily="'Amiri','Tajawal',sans-serif"
        >
          {title}
        </ModalHeader>
        <ModalBody {...adminModalBodyProps}>
          <Text color="var(--text-primary)" fontWeight="600" lineHeight="tall">
            {itemName
              ? `Are you sure you want to ${String(confirmLabel).toLowerCase()} “${itemName}”?`
              : `Are you sure you want to ${String(confirmLabel).toLowerCase()} this item?`}
          </Text>
          <Text mt={2} fontSize="sm" color="var(--text-muted)">
            {message}
          </Text>
        </ModalBody>
        <ModalFooter gap={3} px={8} pb={8} justifyContent="flex-end">
          <Button
            variant="ghost"
            onClick={onClose}
            fontWeight="800"
            color="var(--text-primary)"
            _hover={{ bg: "rgba(91, 13, 22, 0.08)" }}
          >
            Cancel
          </Button>
          <Button
            bg={brandPalette.primary}
            color="white"
            fontWeight="800"
            borderRadius="lg"
            isLoading={isLoading}
            onClick={onConfirm}
            _hover={{ bg: brandPalette.accentDark }}
            boxShadow="0 10px 24px rgba(91, 13, 22, 0.18)"
          >
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteConfirmModal;
